var map = {
	"./Aniversario Corpaidos.jpg": 140,
	"./Campeonato de atletismo.jpg": 1677,
	"./Concurso INTELECTUM.jpg": 9962,
	"./Dia del estudiante.jpg": 4510,
	"./Ensamble musical CORPAIDINO.jpg": 2605,
	"./Feria de Ciencias.jpg": 1089,
	"./Festival de Villancicos.jpg": 9041,
	"./Los MUN.jpg": 626,
	"./Senor de los Milagros.jpg": 3833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5833;